import { Component, Input, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI }       from 'ng-block-ui';
import { NgForm }                   from '@angular/forms';

import { CodeTypeModel }              from '../../app-lite/core/models/code-type';
import { MessagesService }            from '../../app-lite/messages/messages.service';
import { QuickbooksService }          from '../../app-lite/quickbooks/quickbooks.service';
import { QuickbooksSSOSessionModel }  from '../../app-lite/quickbooks/typings/quickbooks.sso-session';
import { QuickbooksSSOSettingsModel } from '../../app-lite/quickbooks/typings/quickbooks.sso-settings';
import { UserModel }                  from '../../app-lite/users/models/user';

@Component({
  selector   : 'wor-quickbooks-signup',
  template: require('./quickbooks.signup.component.html')
})
export class QuickbooksSignupComponent implements OnInit {
  @BlockUI('quickbooksSignupBlock') block : NgBlockUI;

  @Input() country   : string;
  @Input() countries : Array<CodeTypeModel>;

  settings : QuickbooksSSOSettingsModel;
  user     : UserModel = {};

  constructor (
    private messagesService  : MessagesService,
    private quickbooksService: QuickbooksService
  ) {}

  init () : void {
    this.block.start();

    Promise.resolve()
    .then(() => this.quickbooksService.needsAuthentication()
      ? this.quickbooksService.getAuthenticationUrl()
        .then(( url : string ) => window.location.assign(url))
      : this.quickbooksService.getSSOSettings()
        .then(( settings : QuickbooksSSOSettingsModel ) => {
          this.settings = settings;
        }))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  ngOnInit () : void {
    this.user.country = this.country;

    this.init();
  }

  submit ( form : NgForm ) {
    this.block.start();

    this.quickbooksService.signup(this.user, this.settings)
    .then(() => this.quickbooksService.authenticate(this.settings))
    .then(( session : QuickbooksSSOSessionModel ) => this.quickbooksService.login(session))
    .then(( url : string ) => window.location.assign(url))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
